import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CookieManagementService } from 'src/app/account/services/cookie-management.service';
import { getBodyCreator, Service3dsGateCardOpTypes } from './utility-classes/3dsRequest-body';

@Injectable()
export class es3dgateService {
  accessToken = '';

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private cookieManagementService: CookieManagementService
  ) { }

  public service3dsRequest<T>(card_ops_type:Service3dsGateCardOpTypes, params: T) {
    const bodyCreator = getBodyCreator(card_ops_type);

    this.accessToken = this.cookieManagementService.getAccessToken();
    if (this.accessToken == '') {
      return null;
    } else {
      this.accessToken = 'Bearer ' + this.accessToken;

      const headers:HttpHeaders = this.setHeaders();
      const reqBody:URLSearchParams = bodyCreator.setBody(params);

      return this.http.post("/es3dgateRequest.php", reqBody.toString(), {
        headers: headers,
        responseType: 'text',
      })
      .pipe(
        catchError((error) => {
          return throwError(
            this.translate.instant('DEFAULT_ERROR_MESSAGE')
          );
        })
      );
    }

  }

  private setHeaders() : HttpHeaders{
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
  }

}